// extracted by mini-css-extract-plugin
export default {"icon":"LNqtKM8IWiUzYJ8ApiZU","long":"MmsXp1lWx7GmQgw0oapp","normal":"a1ZcfP7hipAAnlVOwW_J"};